module.exports = __webpack_public_path__ + "static/media/loader.88eb738b.png";